<template>
<div>
    <div v-html="content">
  </div>


  <div class="button-area">
    <van-button type="default" size="normal" @click = "refused"> 拒 绝 </van-button>
    <van-button :type="confirmType" :disabled="confirmDisabled" size="normal" class="acceptProtocol"  @click = "accept"> {{acceptStr}} </van-button>
  </div>

</div>
</template>

<script>
import {
  Toast
} from 'vant'
import wx from 'weixin-js-sdk'
import api from '@/fetch/api';
export default {
  data() {
    return {
      username: '',
      mobile: '',
      activeName: 'all',
      acceptStr: "10秒",
      totalTime: 10,
      confirmType:"default",
      confirmDisabled:true,
      content:'',
    };
  },
  created: function() {
    document.title = "槽车在线自助预约排队提货守则";
    var mobile = this.$store.state.wx_info.mobile ? this.$store.state.wx_info.mobile : "";
    //var openid = this.$store.state.wx_info.openid ? this.$store.state.wx_info.openid : "";
    var username = this.$store.state.wx_info.username ? this.$store.state.wx_info.username : "";
    this.$data.username = username;
    this.$data.mobile = mobile;
    this.getsysBcInfo("userprotocol");
  },
  mounted() {
    //var vehicleState = this.$store.state.vehicleState;
    let clock = window.setInterval(() => {
      this.$data.totalTime--
      this.$data.acceptStr = this.$data.totalTime + '秒'
      if (this.$data.totalTime == 0) {
        window.clearInterval(clock)
        this.$data.confirmDisabled = false;
        this.$data.acceptStr = '接受';
        this.$data.confirmType = 'info';
      }
    }, 1000)

  },
  methods: {
    refused()
    {
      Toast.fail('你未同意预约规则，无法进入预约系统');

      wx.closeWindow()
    },
    accept()
    {
      sessionStorage.isAccept = true;
      var mobile = this.$store.state.wx_info.mobile ? this.$store.state.wx_info.mobile : "";

      if(mobile)
      {
        this.$router.push({
          name: 'index',
          query: { bootFlag: 'bindPhone' }
        });
      }
      else
      {
        this.$router.push({
          name: 'userinfo',
          query: { bootFlag: 'firstTime' }
        });
      }
    },
    getsysBcInfo(type)
    {
      var that = this;
      //获取系统信息
      api.getsysBcInfo(type).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var content = res.data;
          that.content = content;
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
    margin-top: .875rem;
    padding: 0 .875rem;
    h1{
      font-weight: bold;
      text-align: center;
      font-size: 1rem;
      margin-bottom: 0.28rem;
    }
    p{
      line-height: 2.5;
      text-indent: 2em;
    }
    .weight{
      font-weight: bold;
    }
}
.button-area
{
  margin: 1rem;
  padding-bottom: env(safe-area-inset-bottom);
  .van-button
  {
    width: 50%;
    text-align: center;
    margin: 0 auto;
  }
  .acceptProtocol{
    background: #316892;
  }
}
</style>
